import React from 'react';
import "./MailboxItem.css";
import UserAvatar from "../../../Controls/UserAvatar.mjs";
import appLib from "../../../libs/appLib.mjs";
import DateLabel from "../../../Controls/DateLabel.mjs";
import TextLabel from "../../../Controls/TextLabel.mjs";
import AttachIcon from "../../../media/images/AttachIcon.mjs";

const G = window.glob;

const MailboxItem = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			playerid: G.getStatus('Player')?.id,
		};
		this.onClick = this.onClick.bind(this);
		this.isMine	= this.isMine.bind(this);
		this.isRead = this.isRead.bind(this);
		this.className = this.className.bind(this);
		this.renderLine = this.renderLine.bind(this);
		this.uid = G.generateUid('MailboxItem');
	}
	onClick(evt) {
		try { evt.preventDefault(); } catch (e) { }
		G.trigger(
			'MessagePreview',
			{
				box: this.props.box,
				message: this.props.data,
				read: this.isRead()
			}
		);
	}
	isMine() {
		const m = this.props.data;
		return (m.player === G.getStatus('Player')?.id) && (this.props.box === 'sent');
	}
	isRead() {
		return this.isMine() || this.props.read;
	}
	className() {
		const cs = ['MailboxItem'];
		if ( ! this.isRead() ) cs.push('unread');
		return cs.join(' ');
	}
	renderLine( m, name, mine, read, className ) {
		return(
			<div
				key={ m.id + read }
				className={ className }
				id={this.uid}
				onClick={ this.onClick }
			>
				<div className={"usericon"}>
					<UserAvatar name={ name } />
				</div>
				<div className={"info"}>
					<div className={"date"}>
						<DateLabel value={m.time}/>
					</div>
					<div className={"people from"}>
						<em>
							<TextLabel value={"From"}/>:
						</em>
						<b>
							{name}{m.external ? <span className={"external"}>EXTERNAL</span> : '' }
						</b>
					</div>
					{ m.to && (
						<div className={"people to"}>
							<em>
								<TextLabel value={"To"}/>:
							</em>
							<b>
								{m.to.map(t => appLib.role2player(t)).join(', ')}
							</b>
						</div>
					)}
					{ m.cc && !! m.cc.length && (
						<div className={"people cc"}>
							<em>
								<TextLabel value={"CC"}/>:
							</em>
							<b>
								{m.cc.map(t => appLib.role2player(t)).join(', ')}
							</b>
						</div>
					)}
					{ m.attachments && m.attachments.length && (
						<div className={"attachments"}>
							{ m.attachments.map((x) => <AttachIcon key={ x?.id }/>) }
						</div>
					)}
					<div className={"subject"}>
						{m.subject}
					</div>
				</div>
			</div>
		);
	}

	render() {
		const m = this.props.data;
		const name = appLib.role2player(m.from);
		const mine = (m.player === G.getStatus('Player')?.id) && (this.props.box === 'sent');
		const read = this.isRead();
		return this.renderLine( m, name, mine, read, this.className() );
	}
}

export default MailboxItem;